import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { WinService } from "src/app/services/win.service";
import { LangService } from "src/app/services/lang/lang.service";
import {
	FormArray,
	FormBuilder,
	FormGroup,
	Validators
} from "@angular/forms";
import { ProductService } from "src/app/services/api/product.service";
import { CartService } from "src/app/services/api/cart.service";
import { FirebaseService } from "src/app/services/firebase.service";
import { Sizing } from "src/app/lib/sizing";
import { DecimalPipe } from "@angular/common";
import { SettingsService } from "src/app/services/site/settings.service";
import { Router } from "@angular/router";
import { DebounceService } from "src/app/services/debounce.service";

@Component({
	selector: "app-quickorder",
	templateUrl: "./quickorder.component.html",
	styleUrls: ["./quickorder.component.scss"],
})
export class QuickorderComponent implements OnInit {
	orderItem: FormGroup;
	numberPattern = /^([0-9.]+$)/;
	submitted: boolean;
	customPrice: any = null;

	products: any = {};
	productsChildren: any = {};
	config: any = {};
	files: any = [];

	matrixPrice: any = {};
	pricing: any = [];
	totalQty: any = 0;
	totalItems: any = 0;
	sizing: any = null;
	activeItems: any = null;
	canShowUpload: any = null;

	constructor(
		public winService: WinService,
		public lang: LangService,
		private title: Title,
		private formBuilder: FormBuilder,
		private router: Router,
		public productService: ProductService,
		public cartService: CartService,
		public firebaseService: FirebaseService,
		public site: SettingsService,
		private decimalPipe: DecimalPipe,
		public debounceService: DebounceService
	) {
		this.canShowUpload = debounceService.debounce((item) => {
			let w = parseFloat(item.value.width);
			let h = parseFloat(item.value.height);
			let qty = parseInt(item.value.qty);
			let sku = item.controls.product.value;

			let product = this.products[sku];

			let additionalLayoutOption = product.options.find(i => ("additional layout" == i.title));
			
			item.can_select_multiLayout = (qty == 10);
			item.controls.can_select_multiLayout.patchValue((qty == 10));

			if(!Number.isNaN(qty)){
				item.controls.qty.patchValue(qty);
			}
			else {
				item.controls.qty.patchValue("");
			}
			item.controls.file.patchValue(null);
			item.controls.files.patchValue(null);
			item.to_upload_files = [];

			if(typeof additionalLayoutOption != 'undefined' && item.can_select_multiLayout){
				item.controls.max_layout.patchValue(additionalLayoutOption.values.length);
				item.max_layout = additionalLayoutOption.values.length;
			}

			if(w && h && qty){
				item.can_show_upload = true;
			}
		}, 600);
	}

	get f() {
		return this.orderItem.controls;
	}
	get t() {
		return this.f.items as FormArray;
	}

	ngOnInit() {
		this.sizing = Sizing;
		// this.title.setTitle("Quick Order");
		window.scrollTo(0, 0);
		this.orderItem = this.formBuilder.group({
			items: new FormArray([]),
			title: [],
		});

		this.firebaseService._uploadProgress = {};

		this.cartService.setLoader(true);
		this.productService.getCustomPrice().then((customPrice) => {
			let cp: any = customPrice;
			if (cp) {
				this.customPrice = customPrice[0];
				this.addNewItem();
				this.cartService.setLoader(false);
			}
			this.cartService
			.get("/rest/entrelable/V1/lns-orderattachment/config")
			.subscribe((config) => {
				this.config = config[0];
			});
		});

		this.site.getConfigPromise("/rest/entrelable/V1/lns-entrelabel/config/site/setting","site_settings").then((config) => {
			let c: any = config;
			if (typeof c.site_settings != "undefined") {

				let activeItemsTemp = [];
				c.site_settings.active_items.forEach((val, key) => {
					if(val.quick_order_page){
						activeItemsTemp.push(val);
					}
				});
				this.activeItems = activeItemsTemp;		
				this.activeItems.forEach(item => {
					this.getProduct(item.sku).then((itemObject) => {
					});
				});
			}
		});
	}


	setProduct(item, e){
		let sku = e.target.value;

		if(typeof this.products[sku] != 'undefined'){
			let product = this.products[sku];

			let options = product.options;

			item['has_adhesive'] = false;
			item['has_adhesive_options'] = [];
			item['can_show_upload'] = false;
			item['to_upload_files'] = [];

			item['max_layout'] = 1;
			item['can_select_multiLayout'] = false;

			item.controls.adhesive.patchValue('');

			item['has_cutting_type'] = false;

			item['custom_options_pricing_breakdown'] = [];

			options.forEach(opt => {
				if(opt.title == 'cutting type'){
					item['has_cutting_type'] = opt;
					item.controls.cutting_type.patchValue(opt.values[0].option_type_id);
					this.setCuttingTypeCustomOption(item);
				}
			});
		}
	}

	getPerentAndChild(sku) {
		return new Promise((res) => {
			this.getProduct(sku).then((prod) => {
				this.getProductChildren(sku).then((child) => {
					res(true);
				});
			});
		});
	}

	validatorGetProduct(formControl){
		try {
			let controls = formControl._parent.controls;
			let sku = controls.product.value;
			if(sku){
				if(typeof this.products[sku] != 'undefined'){
					if(typeof this.products[sku].use_sicker_roll_pricing == 'undefined'){
						this.products[sku].use_sicker_roll_pricing = this.productService.getCustomAttr('use_sicker_roll_pricing', this.products[sku]) + ""; 

						if(this.products[sku].use_sicker_roll_pricing.length){
							let epr = this.productService.getCustomAttr('entrelabel_price_range', this.products[sku]); 	
							this.products[sku].entrelabel_price_range = JSON.parse(epr);
						}
					}
					return this.products[sku];
				}
				else {
					return null;
				}
			}
			else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	validatorQty(formControl, shape){
		try {
			let controls = formControl._parent.controls;
			let sku = controls.product.value;
			if(sku){
				if(typeof this.products[sku] != 'undefined'){
					let product = this.products[sku];
					let width = controls.width.value;
					let height = controls.height.value;

					let matrixPriceKey = sku + shape + width + height;

					
					let inputQty = parseInt(formControl.value);
					let priceRange = this.matrixPrice[matrixPriceKey].find(range => {
						const min = range.from;
						const max = range.to === "*" ? Infinity : range.to;
						return inputQty >= min && inputQty <= max;
					});

					if(typeof priceRange != "undefined"){
						return null;
					}
					else {
						return { min: true };
					}

					// if (this.matrixPrice[matrixPriceKey]) {
					// 	let minQty = this.matrixPrice[matrixPriceKey][0]['from'];
					// 	formControl["min_qty"] = minQty;
					// 	if(parseInt(minQty) <= parseInt(formControl.value)){
					// 		return null;
					// 	}
					// 	else {
					// 		return { min: true };
					// 	}
					// }
					// else {
					// 	return { min: true };
					// }
				}
				else {
					return { min: true };
				}
			}
			else {
				return { min: true };
			}
		} catch (error) {}
	}

	validatorSize(formControl, maxValue, sizeType){
		let v = formControl.value + "";
		if(!v.length){
			return { required: true };
		}
		else {
			// pattern
			const regex = /^\d+(\.\d+)?$/;
  			if(!regex.test(v)){
				return { pattern: true };
			}
			else {
				let product = this.validatorGetProduct(formControl);
				if(product){
					if(product.use_sicker_roll_pricing.length){
						if(sizeType == "height"){
							return null;
						}
						else {
							if(typeof product.entrelabel_price_range != 'undefined'){
								maxValue = product.entrelabel_price_range.max_size.width;
							}
							else {
								return null;
							}
						}
					}

					if(parseFloat(v) <= parseFloat(maxValue)){
						return null;
					}
					else {
						formControl["max_"+sizeType] = maxValue;
						return { max: true };
					}
				}
				else {
					return { max: true };
				}
			}
		}
	}

	/**
	 * add item
	 */
	addNewItem() {
		/**
		 * because Jeanine wish to remove shape first
		 * we will set a static value for this for now
		 */
		let shape = "Custom Shape";
		this.t.push(
			this.formBuilder.group({
				file: [null],
				files: [null],
				product: ["", Validators.required],
				shape: [shape, Validators.required],
				qty: ["", [Validators.required, Validators.pattern(this.numberPattern), (formControl) => { return this.validatorQty(formControl, shape); }]],
				width: ["", [Validators.pattern(this.numberPattern), (formControl) => { 
					return this.validatorSize(formControl, this.sizing.maxWidth, "width"); 
				}]],
				height: ["", [Validators.pattern(this.numberPattern), (formControl) => { 
					return this.validatorSize(formControl, this.sizing.maxHeight, "height"); 
				}]],
				adhesive: [""],
				cutting_type: [""],
				max_layout: [1],
				can_select_multiLayout: [false]
			})
		);
	}

	/**
	 * remove item
	 */
	removeItem(i) {
		this.t.removeAt(i);
		if (this.t.length <= 0) {
			this.submitted = false;
		}
	}

	// Make the size input only 1 decimal place
	decimalPipe_transform(item:any){
		let width = item.value.width;
		let height = item.value.height;
		if (height != ""){
			item.value.height = parseFloat(this.decimalPipe.transform(height, "2.1-1"));
		}
		if(width != ""){
			item.value.width = parseFloat(this.decimalPipe.transform(width, "2.1-1"));
		}
	}

	// canShowUpload(item:any){
	// 	let w = parseFloat(item.value.width);
	// 	let h = parseFloat(item.value.height);
	// 	let qty = parseInt(item.value.qty);
	// 	let sku = item.controls.product.value;

	// 	let product = this.products[sku];

	// 	let additionalLayoutOption = product.options.find(i => ("additional layout" == i.title));
		
	// 	item.can_select_multiLayout = (qty == 10);
	// 	item.controls.can_select_multiLayout.patchValue((qty == 10));

	// 	if(typeof additionalLayoutOption != 'undefined' && item.can_select_multiLayout){
	// 		item.controls.max_layout.patchValue(additionalLayoutOption.values.length);
	// 		item.max_layout = additionalLayoutOption.values.length;
	// 	}

	// 	if(w && h && qty){
	// 		item.can_show_upload = true;
	// 	}
	// }

	get getTotalQty() {
		let _qty = 0;
		this.t.controls.forEach((item) => {
			let qty = parseInt(item.value.qty);
			_qty += qty;
		});
		this.totalQty = _qty;
		this.totalItems = this.t.controls.length;
		return false;
	}

	/**
	 * get price per qty
	 */
	getPrice(item: any = null, index: number = 0) {
		/** this is the SKU */
		let product: any = item.value.product;

		item["pricing"] = {
			per_piece: 0,
			total: 0,
			discount: 0,
			discounted_per_piece: 0,
		};
		let shape: any = item.value.shape;
		let width: any = item.value.width;
		let height: any = item.value.height;
		let qty: any = item.value.qty;

		let fieldStatus = [
			item.controls.product.status,
			item.controls.height.status,
			item.controls.width.status
		];
		const allValid = fieldStatus.every(status => status === 'VALID');

		// if (qty <= 9) {
		// 	/* do nothing here */
		// } else {
			// if (product && width && height && qty) {
			if (allValid) {
				let url = "/rest/entrelable/V1/lns-entrelabel/pricing/";
				url += width + "/" + height + "/" + product + "/" + shape;
				let matrixPriceKey = product + shape + width + height;
				if (!this.matrixPrice[matrixPriceKey]) {
					this.matrixPrice[matrixPriceKey] = [];
					this.cartService.get(url).subscribe(
						(pricing) => {
							this.matrixPrice[matrixPriceKey] = pricing;
							item["pricing"] = this.getPriceHelper(pricing, qty, item);
						},
						(error) => {
							this.cartService.errorHandler(error);
						}
					);
				} else {
					item["pricing"] = this.getPriceHelper(this.matrixPrice[matrixPriceKey], qty, item);
				}
			}
		// }
		return true;
	}

	getPriceHelper(pricing, qty, item) {
		let totals = {
			per_piece: 0,
			total: 0,
			discount: 0,
			discounted_per_piece: 0,
		};

		pricing.forEach((price) => {
			let from = parseFloat(price.from);
			if (price.to == "*") {
				if (qty >= from) {
					totals.per_piece = price.price;
				}
			} else {
				if (qty >= from && qty <= price.to) {
					totals.per_piece = price.price;
				}
			}
		});

		let stickerPadId:string = null;
		if(item.has_cutting_type){
			item.has_cutting_type.values.forEach(val => {
				if(val.title == 'Sticker Pad') {
					stickerPadId = val.option_type_id + '';
				}
			});
		}

		item.custom_options_pricing_breakdown.forEach(cOptnPrice => {
			if(cOptnPrice.title == 'cutting type' && stickerPadId == item.value.cutting_type){
				let totalCuttingTypeFee = (parseFloat(item.value.qty) * totals.per_piece) + cOptnPrice.price;
				let totalCuttingTypeFeePerPiece = totalCuttingTypeFee / item.value.qty;

				totals.per_piece += totalCuttingTypeFeePerPiece;
			}
			else {
				totals.per_piece += cOptnPrice.price;
			}
		});

		totals.total = totals.per_piece * qty;

		let items = this.orderItem.value.items;

		let totalQty = 0;
		items.forEach((item) => {
			totalQty += parseInt(item.qty);
		});

		let product = this.products[item.value.product];

		if(typeof product.use_sicker_roll_pricing == 'undefined'){
			product.use_sicker_roll_pricing = this.productService.getCustomAttr('use_sicker_roll_pricing', product) + ""; 
		}

		if(product.use_sicker_roll_pricing.length){
			/** do nothing */
		}
		else {
			let discount = this.customPrice.discount;
			discount.forEach((dis) => {
				if (dis.to == "*") {
					if (this.totalQty >= dis.from) {
						totals.discount = dis.discount;

						let discountPrice = totals.per_piece * (dis.discount / 100);
						let discountedPrice = totals.per_piece - discountPrice;

						totals.discounted_per_piece = this.cartService.formatNumber(discountedPrice, 2);
						totals.total = totals.discounted_per_piece * qty;
					}
				} else {
					if (this.totalQty >= dis.from && this.totalQty <= dis.to) {
						totals.discount = dis.discount;

						let discountPrice = totals.per_piece * (dis.discount / 100);
						let discountedPrice = totals.per_piece - discountPrice;

						totals.discounted_per_piece = this.cartService.formatNumber(discountedPrice, 2);
						totals.total = totals.discounted_per_piece * qty;
					}
				}
			});
		}
		return totals;
	}

	get subTotal() {
		let items = this.t.controls;
		let subTotal: any = 0;
		items.forEach((item, key) => {
			if (item["pricing"]) {
				subTotal += item["pricing"].total;
			}
		});
		return subTotal;
	}

	/**
	 * save the orders in cart
	 */
	addToCart() {
		this.submitted = true;
		if (this.orderItem.invalid) {
			return;
		} else {
			let items = this.orderItem.value.items;

			this.cartService.toastService.setAddingToCartItems(items);
			
			this.addToCartHelper(items).then((cartItemData) => {
				
				let items: any = cartItemData;
				let lastKey = items.length - 1;
				let key = 0;

				this.addToCartRequest(items, 0).then((added) => {
					items.forEach((val, key) => {
						this.removeItem(key);
						this.cartService.toastService.closeToastMessage();
						this.router.navigate(["/cart"]);
					});
				});
			});
		}
	}

	addToCartHelper(items) {
		return new Promise((data) => {
			this.cartService.getCartId().then((quote_id) => {
				let itemTotalCount = items.length;
				let cartItemData = [];

				items.forEach((item, key) => {
					let jsonData = {
						cartItem: {
							sku: item.product,
							qty: item.qty,
							quote_id: quote_id,
							product_option: {
								extension_attributes: {
									configurable_item_options: [],
									custom_options: [],
								},
							},
							extension_attributes: {},
						},
					};

					let childSku = item.product + "-" + item.shape;

					this.getProduct(item.product).then((product) => {
						let _prod: any = product;

						this.getProductChildren(item.product).then((children) => {
							let childs: any = children;

							let config_option_value = "";

							childs.forEach((child) => {
								if (child.sku == childSku) {
									let ca = child.custom_attributes;

									ca.forEach((caVal) => {
										if (caVal.attribute_code == "sticker_shape") {
										config_option_value = caVal.value;
										}
									});
								}
							});

							let configurables = _prod.extension_attributes.configurable_product_options;
							configurables.forEach((val) => {
								jsonData.cartItem.product_option.extension_attributes.configurable_item_options.push({
									option_id: "" + val.attribute_id,
									option_value: config_option_value,
								});
							});

							let d = new Date();

							let customOption: any = [];
							_prod.options.forEach((opt) => {
								if (opt.title == "custom size") {
									customOption.push({
										option_id: opt.option_id,
										option_value: item.width + " x " + item.height,
									});
								}
								if (opt.title == "do not merge") {
									customOption.push({
										option_id: opt.option_id,
										option_value: key + "_" + d.getTime(),
									});
								}
								if (opt.title == "adhesive" && item.adhesive) {
									customOption.push({
										option_id: opt.option_id,
										option_value: item.adhesive,
									});
								}
								if (opt.title == "cutting type") {
									customOption.push({
										option_id: opt.option_id,
										option_value: item.cutting_type,
									});
								}

								if (opt.title == "additional layout") {
									let additionalLayout = {
										option_id: opt.option_id,
										option_value: ""
									}

									if(item.files){
										/** the first layout is free we shouldn't add it here */
										let option_value = [];
										let filesCount = item.files.length - 1;
										for (let index = 0; index < filesCount; index++) {
											option_value.push(opt.values[index].option_type_id)
										}
										additionalLayout.option_value = option_value.join(',');
										
										customOption.push(additionalLayout);
									}
								}
							});

							jsonData.cartItem.product_option.extension_attributes.custom_options = customOption;

							cartItemData.push({
								jsonData: jsonData,
								item: item,
							});
							if (itemTotalCount - 1 == key) {
								data(cartItemData);
							}
						});
					});
				});
			});
		});
	}

	/**
	 * loop trough each item
	 */
	addToCartRequest(items: any = null, key: any = 0) {
		return new Promise((added) => {
			let item = items[key];
			// this.cartService.setLoader(true);
			this.cartService.addToCart(item.jsonData).then((addToCart) => {
				let atc: any = addToCart;
				let next = key + 1;


				if (item.item.files) {
					this.uploadToFirebase(atc, item.item.files, key)
					.then((url) => {
						if (typeof items[next] != "undefined") {
							added(this.addToCartRequest(items, next));
						} 
						else {
							this.cartService
							.applyCartDiscount(atc.quote_id, atc.item_id, false, true, false)
							.then((discount) => {
								this.cartService.getCart().then((cart) => {
								if (items.length > 1) {
									this.cartService.toastService.add("A total of " + items.length + " item/s was added to your cart", "success");
								} else {
									this.cartService.toastService.add("The item is added to your cart", "success");
								}
								this.cartService.setLoader(false);
									added(true);
								});
							});
						}
						
						this.cartService.toastService.setItemAdded(1);
					});
				} 
				else {
					if (typeof items[next] != "undefined") {
						added(this.addToCartRequest(items, next));
					} 
					else {
						this.cartService
						.applyCartDiscount(atc.quote_id, atc.item_id, false, true, false)
						.then((discount) => {
							this.cartService.getCart().then((cart) => {
								if (items.length > 1) {
									this.cartService.toastService.add("A total of " + items.length + " item/s was added to your cart", "success");
								} else {
									this.cartService.toastService.add("The item is added to your cart", "success");
								}
								this.cartService.setLoader(false);
								added(true);
							});
						});
					}
					
					this.cartService.toastService.setItemAdded(1);
				}

				// if (item.item.file) {
				// 	let file = item.item.file.file;

				// 	this.uploadToFirebase(atc.quote_id, file, key).then((url) => {
				// 		this.saveAttchement(atc.item_id, url).then((attachment) => {
				// 			if (typeof items[next] != "undefined") {
				// 				added(this.addToCartRequest(items, next));
				// 			} else {
				// 				this.cartService
				// 				.applyCartDiscount(atc.quote_id, atc.item_id, false, true, false)
				// 				.then((discount) => {
				// 					this.cartService.getCart().then((cart) => {
				// 					if (items.length > 1) {
				// 						this.cartService.toastService.add("A total of " + items.length + " item/s was added to your cart", "success");
				// 					} else {
				// 						this.cartService.toastService.add("The item is added to your cart", "success");
				// 					}
				// 					this.cartService.setLoader(false);
				// 						added(true);
				// 					});
				// 				});
				// 			}
							
				// 			this.cartService.toastService.setItemAdded(1);
				// 		});
				// 	});
				// } 
				// else {
				// 	if (typeof items[next] != "undefined") {
				// 		added(this.addToCartRequest(items, next));
				// 	} 
				// 	else {
				// 		this.cartService
				// 		.applyCartDiscount(atc.quote_id, atc.item_id, false, true, false)
				// 		.then((discount) => {
				// 			this.cartService.getCart().then((cart) => {
				// 				if (items.length > 1) {
				// 					this.cartService.toastService.add("A total of " + items.length + " item/s was added to your cart", "success");
				// 				} else {
				// 					this.cartService.toastService.add("The item is added to your cart", "success");
				// 				}
				// 				this.cartService.setLoader(false);
				// 				added(true);
				// 			});
				// 		});
				// 	}
					
				// 	this.cartService.toastService.setItemAdded(1);
				// }
			});
		});
	}

	uploadToFirebase(cartData, filesArray, key, fileKey: any = 0) {
		let file = filesArray[fileKey];

		return this.firebaseService
		.setFile({
			target: { files: [file] }
		})
		.setPath('order/quote_' + cartData.quote_id + '/')
		.uploadToServer('progress_' + key)
		.then(url => {

			return this.saveAttchement(cartData.item_id, url)
				.then(() => {

					let nextKey = fileKey + 1;

					if (filesArray[nextKey]) {
						// 🔁 recursively return the NEXT promise
						return this.uploadToFirebase(
							cartData,
							filesArray,
							key,
							nextKey
						);
					} else {
						// ✅ final resolve
						return url;
					}

				});

		});
	}


	// uploadToFirebase(addToCart, files, key, fileKey: any = 0) {
	// 	let atc = addToCart;
	// 	return new Promise((resolve) => {
	// 		let file = files[fileKey];

	// 		this.firebaseService
	// 		.setFile({
	// 			target: {
	// 				files: [file]
	// 			}
	// 		})
	// 		.setPath('order/quote_'+ addToCart.quote_id + '/')
	// 		.uploadToServer('progress_'+key).then(url => {
	// 			this.saveAttchement(atc.item_id, url).then((attachment) => {

	// 				let nextKey = fileKey + 1;
	// 				if(typeof files[nextKey] != 'undefined'){
	// 					resolve(this.uploadToFirebase(addToCart, files, key, nextKey));
	// 				}
	// 				else {
	// 					resolve(url);
	// 				}
	// 			});
	// 		});
	// 	});
	// }

	/**
	 * save the attachment to the database
	 */
	saveAttchement(item_id, firestoreLink) {
		return new Promise((resolve) => {
			let attachmentData = {
				item_id: item_id,
				firesotre_link: firestoreLink,
				firestore_task: {
					uploadUrl_: this.firebaseService.task.task.uploadUrl_,
					location: this.firebaseService.task.task.location_,
					metadata_: this.firebaseService.task.task.metadata_,
					instructions: "",
					filename: this.firebaseService.newFilename,
				},
			};
			this.cartService.saveAttachment(attachmentData).then((r) => {
				resolve(r);
			});
		});
	}

	/**
	 * get the product form API
	 */
	getProduct(sku) {
		return new Promise((product) => {
			this.productService.storage.get(sku).then((_product) => {
				if (_product) {
					this.products[sku] = _product;
					product(this.products[sku]);
				} else {
					this.productService.get("/rest/entrelable/V1/products/" + sku).subscribe(
						(prod) => {
							this.products[sku] = prod;
							this.productService.storage.setLocal(sku,prod,Sizing.productStorageExp);
							product(prod);
						},
						(error) => this.productService.errorHandler(error)
					);
				}
			});
		});
	}

  /**
   * get the product form API
   */
  getProductChildren(sku) {
    let storageKey = sku + "_children";
    return new Promise((children) => {
      this.productService.storage.get(storageKey).then((_children) => {
        if (_children) {
          this.productsChildren[sku] = _children;
          children(this.productsChildren[sku]);
        } else {
          this.productService
            .get(
              "/rest/entrelable/V1/configurable-products/" + sku + "/children"
            )
            .subscribe(
              (_children) => {
                this.productsChildren[sku] = _children;
                this.productService.storage.setLocal(
                  storageKey,
                  _children,
                  Sizing.productStorageExp
                );
                children(_children);
              },
              (error) => this.productService.errorHandler(error)
            );
        }
      });
    });
  }

  /**
   * open the file browser to prepare upload
   */
  openFileBrowser(event: any, idNo: number) {
    event.preventDefault();
    let el: HTMLElement = document.getElementById(
      "input_file_artwork_" + idNo
    ) as HTMLElement;
    el.click();
  }

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event: any, items) {
		// let sku = items.value.product;
		// let product = this.products[sku];
		// let qty = parseInt(items.value.qty);

		let maxLayouts = 1;
		if(items.can_select_multiLayout){
			maxLayouts = items.max_layout
		}

		items.to_upload_files = [];
		
		for (let index = 0; index < maxLayouts; index++) {
			
			if(typeof event.target.files[index] != 'undefined'){

				let fName = event.target.files[index].name;
				let ext = fName.split(".");
				ext = ext[ext.length - 1];
				ext = ext.toLowerCase();

				if (this.config.accepted_file_type[ext]) {
					items.to_upload_files.push(event.target.files[index])
					// let file = {
					// 	fileName: fName,
					// 	file: event,
					// };
					// items.patchValue({file: file,});
				} 
				// else {
				// 	items.patchValue({
				// 		file: "",
				// 	});
				// 	let types: any = [];
				// 	for (var key in this.config.accepted_file_type) {
				// 		if (this.config.accepted_file_type.hasOwnProperty(key)) {
				// 			types.push(key);
				// 		}
				// 	}
				// 	types = types.join(", ");
				// 	this.cartService.toastService.add("Please upload " + types + " only", "danger");
				// }
			}
		}

		setTimeout(() => {
			items.patchValue({files: items.to_upload_files});
		}, 500);


	}

  isNumberKey(evt: any) {
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode == 9 ||
      charCode == 8 ||
      charCode == 110 || 
      charCode == 190 ||
      (charCode >= 96 && charCode <= 105) ||
      (charCode >= 48 && charCode <= 57) ||
      (charCode >= 37 && charCode <= 40)
    ) {
      return true;
    } else {
      return false;
    }
  }

	getSizeError(items) {
		let errorMsg: any = null;

		if (items.controls.width.errors) {
			if (items.controls.width.errors.required) {
				errorMsg = "Size is required";
			} else if (items.controls.width.errors.pattern) {
				errorMsg = "Invalid size";
			} else if (items.controls.width.errors.max && typeof items.controls.width.max_width != 'undefined') {
				errorMsg = "Max width: " + items.controls.width.max_width + " " + this.sizing.unit;
			}
		} else if (items.controls.height.errors) {
			if (items.controls.height.errors.required) {
				errorMsg = "Size is required";
			} else if (items.controls.height.errors.pattern) {
				errorMsg = "Invalid size";
			} else if (items.controls.height.errors.max) {
				errorMsg ="Max height: " + this.sizing.maxHeight + " " + this.sizing.unit;
			}
		}

		return errorMsg;
	}

	// getQtyError(items) {
	// 	let errorMsg: any = null;
	// 	if (items.controls.qty.errors) {
	// 		errorMsg = "Invalid quantity";
			
	// 		// if (this.submitted && items.controls.qty.errors.required) {
	// 		// 	errorMsg = "Quantity is required";
	// 		// } else if (this.submitted && items.controls.qty.errors.pattern) {
	// 		// 	errorMsg = "Invalid quantity";
	// 		// } else if (items.controls.qty.errors.min && typeof items.controls.qty.min_qty != "undefined") {
	// 		// 	errorMsg = "Minimum of "+items.controls.qty.min_qty+" pcs";
	// 		// }
	// 	}
	// 	return errorMsg;
	// }

	addPricingBreakdown(customOptionsPricingBreakdown, title, price){
		let isAdded = false;
		customOptionsPricingBreakdown.forEach((val, key) => {
			if(val.title == title){
				customOptionsPricingBreakdown[key]['price'] = price;
				isAdded = true;
			}
		});
		if(!isAdded){
			customOptionsPricingBreakdown.push({
				title: title,
				price: price,
				total: 0
			});
		}
	}


	setCuttingTypeCustomOption(items){
		let selectedValue = items.controls.cutting_type.value;

		if(items.has_cutting_type){
			items.has_cutting_type.values.forEach(cusOptnVal => {
				if(cusOptnVal.option_type_id + '' == selectedValue + ''){
					this.addPricingBreakdown(items.custom_options_pricing_breakdown, items.has_cutting_type.title, cusOptnVal.price);
				}
			});
		}
	}
}
